import { Modal } from '../../../../../../core/components/templates/Modal';
import Player from '../../../../../../core/components/molecules/Player';
import { MODAL_VIDEOS_VIMEO_ALLOWED } from '../../../../../../core/constants/modal-videos';

interface AboutMyEssaysModalProps {
  isOpen: boolean;
  onClose: () => void;
}

function AboutMyEssaysModal({ isOpen, onClose }: AboutMyEssaysModalProps) {
  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      size='md'
      title='Saiba mais Sobre Minhas Redações'
    >
      <Player
        playerType='vimeo'
        className='h-[265px]'
        token={MODAL_VIDEOS_VIMEO_ALLOWED.MINHAS_REDACOES.token}
        initialTime={0}
      />
    </Modal>
  );
}

export { AboutMyEssaysModal };
